module.exports = __webpack_public_path__ + "static/media/center.8973efa7.svg";